import { connect } from "react-redux";
import ParticipantList from "./ParticipantList";
import { getSPParticipantsListRequest, getSpSettingFetchRequest, resetParticipantList } from "../../../store/actions/sp.actions";
import {
  getParticipantsList,
  getSpParticipantsListLoading,
  getSpSetting,
} from "../../../store/selector/sp.selector";

import {
  getSupportCoordinatorLoader,
  getSupportCoordinator,
} from "../../../store/selector/cos.selector";
import { supportCoordinatorsRequest } from "../../../store/actions/cos.actions";
import { getUser } from "store/selector/auth.selector";

const mapDispatchToProps = {
  getParticipantList: getSPParticipantsListRequest,
  getSupportCoordinators: supportCoordinatorsRequest,
  getSpSettingRequest: getSpSettingFetchRequest,
  resetParticipantListInParticipant:resetParticipantList
};

const mapStateToProps = (state) => {
  const spParticipants = getParticipantsList(state);
  const loading = getSpParticipantsListLoading(state);

  const supportCoordinator = getSupportCoordinator(state);
  const supportCoordinatorLoader = getSupportCoordinatorLoader(state);
  const settings=getSpSetting(state);
  const loginUser=getUser(state)

  return {
    loading,
    spParticipants,
    supportCoordinator,
    supportCoordinatorLoader,
    settings,
    loginUser,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantList);
